/* global axios */
import ApiClient from './ApiClient';

class ImportAPI extends ApiClient {
  constructor() {
    super('import', { accountScoped: true });
  }

  uploadFile(file, inboxId) {
    const formData = new FormData();
    formData.append('excelFile', file);
    formData.append('inboxId', inboxId);

    return axios.post(`${this.url}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  importContactsBatch(inboxId, blobId, batchNumber, batchSize) {
    return axios.post(`${this.url}/contacts_batch`, {
      inboxId,
      blobId,
      batchNumber,
      batchSize,
    });
  }

  deleteContacts(fileName) {
    return axios.post(`${this.url}/delete`, { fileName });
  }

  deleteContactsBatch(fileName, batchNumber, batchSize) {
    return axios.post(`${this.url}/delete_batch`, {
      fileName,
      batchNumber,
      batchSize,
    });
  }

  deleteFile(fileName) {
    return axios.post(`${this.url}/delete_file`, { fileName });
  }

  fetchImports() {
    return axios.get(`${this.url}/list`);
  }
}

export default new ImportAPI();
